/**
 * @voltxampere/schema — ViewportState
 *
 * Per SPECS §1.7. The canvas viewport (pan center, zoom factor, optional
 * rotation). Persisted so circuit open restores the last camera.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
import { PointSchema } from "./_primitives.js";
export const ViewportStateSchema = z
    .object({
    center: PointSchema,
    zoom: z.number().positive(),
    rotation: z.number().default(0),
})
    .strict();
//# sourceMappingURL=viewport-state.js.map